//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { Modal, Checkbox, Input } from '@gamesb42/ui-kit';

import s from './styles.module.scss';

interface EditUaSpendModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  initialValue?: any;
  loading?: boolean;
}

const UA_SPEND_OPTIONS = [
  { label: 'Facebook', key: 'facebook' },
  { label: 'Google Ads', key: 'googleAds' },
  { label: 'Apple Search Ads', key: 'appleSearchAds' },
  { label: 'Snapchat', key: 'snapchat' },
  { label: 'Tik Tok', key: 'tikTok' },
  { label: 'UnityAds', key: 'unityAds' },
];

export function EditUaSpendModal({ isOpen, onClose, onSave, initialValue, loading }: EditUaSpendModalProps) {
  const [selectedOptions, setSelectedOptions] = useState<Record<string, boolean>>({});
  const [otherComment, setOtherComment] = useState('');

  useEffect(() => {
    // Initialize values when modal opens
    if (isOpen) {
      if (!initialValue) {
        setSelectedOptions({});
        setOtherComment('');
      } else {
        // Инициализируем чекбоксы на основе данных
        const newSelectedOptions: Record<string, boolean> = {};

        UA_SPEND_OPTIONS.forEach((option) => {
          newSelectedOptions[option.key] = initialValue[option.key] || false;
        });

        setSelectedOptions(newSelectedOptions);

        // Извлекаем комментарий из otherComment, если есть
        if (initialValue.other && initialValue.otherComment) {
          setOtherComment(initialValue.otherComment);
        } else {
          setOtherComment('');
        }
      }
    }
  }, [isOpen, initialValue]);

  const handleCheckboxChange = (key: string, checked: boolean) => {
    setSelectedOptions({
      ...selectedOptions,
      [key]: checked,
    });
  };

  const handleSave = () => {
    const result = {
      uaSpend: {
        ...selectedOptions,
        other: otherComment.trim().length > 0,
        otherComment: otherComment.trim(),
        dontKnow: false, // Убираем "I don't know"
      },
    };
    onSave(result);
  };

  const handleCancel = () => {
    setSelectedOptions({});
    setOtherComment('');
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onCancel={handleCancel}
      title="UA spends sources"
      okText="Save"
      cancelText="Cancel"
      okButtonProps={{
        onMouseDown: handleSave,
        disabled: loading,
        loading: loading,
      }}
      cancelButtonProps={{
        disabled: loading,
      }}
      width={720}
    >
      <div className={s.modalContent}>
        {UA_SPEND_OPTIONS.map((option) => (
          <div key={option.key} className={s.checkboxItem}>
            <Checkbox
              checked={selectedOptions[option.key] || false}
              onChange={(e) => handleCheckboxChange(option.key, e.target.checked)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}

        <div className={s.otherSection}>
          <Input.TextArea
            value={otherComment}
            onChange={(e) => setOtherComment(e.target.value)}
            placeholder="Other (Add comment)"
            rows={4}
            className={s.otherInput}
          />
        </div>
      </div>
    </Modal>
  );
}
